import { combineReducers } from "redux";
import FamilyDetailTable from "./pagecomponents/familyTable/reducer";
import ProfileDetailTable from "./pagecomponents/WardPortal1/reducer";
import HomePageReducer from "./pages/reducer";
import LoginReducer from "./pagecomponents/Login/reducer";
import AdminHomePageReducer from "./admin/pagecomponents/Homepage/redux/reducer";
import VaccineReducer from "./pagecomponents/DataDirectory/Vaccination Data/reducer";
import HouseHoldReducer from "./pagecomponents/DataDirectory/HouseHoldData/reducer";
import PopulationReducer from "./pagecomponents/DataDirectory/PopulationData/reducer";
import HealthReducer from "./pagecomponents/DataDirectory/HealthData/reducer";
import NotificationReducer from "./pagecomponents/HomePage/reducer";
export default combineReducers({
  FamilyDetailTable,
  ProfileDetailTable,
  LoginReducer,
  HomePageReducer,
  AdminHomePageReducer,
  VaccineReducer,
  HouseHoldReducer,
  PopulationReducer,
  HealthReducer,
  NotificationReducer,
});
